import { useId } from 'react';

export default function Coin({ className = '' }: { className?: string }) {
  const id = useId().replace(/:/g, '');
  const face = `${id}-coinFace`;
  const rim = `${id}-coinRim`;

  return (
    <svg
      viewBox="0 0 16 16"
      className={`inline-block h-3.5 w-3.5 shrink-0 align-[-0.125em] ${className}`}
      aria-hidden
      focusable="false"
    >
      <defs>
        <linearGradient id={face} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#f0d56a" />
          <stop offset="45%" stopColor="#c9a227" />
          <stop offset="100%" stopColor="#8a7020" />
        </linearGradient>
        <linearGradient id={rim} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#e8c547" />
          <stop offset="100%" stopColor="#6e5818" />
        </linearGradient>
      </defs>
      <circle cx="8" cy="8" r="7.5" fill={`url(#${rim})`} />
      <circle cx="8" cy="8" r="6.1" fill={`url(#${face})`} />
      <circle
        cx="8"
        cy="8"
        r="5.2"
        fill="none"
        stroke="#6e5818"
        strokeOpacity="0.55"
        strokeWidth="0.6"
      />
      <path
        d="M5.2 9.6V6.1l1.55 1.15L8 5.2l1.25 2.05L10.8 6.1v3.5H5.2z"
        fill="#5c4a14"
        fillOpacity="0.85"
      />
      <ellipse cx="6.2" cy="5.4" rx="3.2" ry="1.6" fill="#fff" fillOpacity="0.2" />
    </svg>
  );
}
